import { render, staticRenderFns } from "./ReservationReport.vue?vue&type=template&id=65ad7f16&"
import script from "./ReservationReport.vue?vue&type=script&lang=js&"
export * from "./ReservationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports